import { useMutation, useQueryClient } from '@tanstack/react-query';
import useGlynt from '../useGlynt';
import { IRQCallbacks } from '../../../types/my-types';

const useUpdateChangeTicket = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, standard_vendor_name }: { id: number; standard_vendor_name: string | null }) => {
      return (await glynt).vendor.updateChangeTicket(id, { standard_vendor_name });
    },

    ...callbacks,

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ['vendor-change-tickets-all']
      });
      queryClient.invalidateQueries({
        queryKey: ['vendor-change-tickets']
      });
      queryClient.invalidateQueries({
        queryKey: ['mat-discovery-full']
      });
    }
  });
};

export default useUpdateChangeTicket;
